/* eslint-disable */

/** unique or primary key constraints on table "argo.work_order" */
export enum ArgoWorkOrderConstraint {
  /** unique or primary key constraint on columns "work_order_id" */
  WorkOrderPkey = 'work_order_pkey',
  /** unique or primary key constraint on columns "context_id", "order_number" */
  WorkOrderUniqueOrderNumber = 'work_order_unique_order_number'
}

/** select columns of table "argo.work_order" */
export enum ArgoWorkOrderSelectColumn {
  /** column name */
  ActualStart = 'actual_start',
  /** column name */
  Completed = 'completed',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialModelId = 'material_model_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  OrderNumber = 'order_number',
  /** column name */
  PlannedStart = 'planned_start',
  /** column name */
  Restriction = 'restriction',
  /** column name */
  Status = 'status',
  /** column name */
  StatusNote = 'status_note',
  /** column name */
  TargetQuantity = 'target_quantity',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** update columns of table "argo.work_order" */
export enum ArgoWorkOrderUpdateColumn {
  /** column name */
  ActualStart = 'actual_start',
  /** column name */
  Completed = 'completed',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialModelId = 'material_model_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  OrderNumber = 'order_number',
  /** column name */
  PlannedStart = 'planned_start',
  /** column name */
  Restriction = 'restriction',
  /** column name */
  Status = 'status',
  /** column name */
  StatusNote = 'status_note',
  /** column name */
  TargetQuantity = 'target_quantity',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

